try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}
// With webpack everything is a dependency of
import '@/scss/main.scss'; // @ is a alias to the src folder

import Vue from 'vue';

new Vue({
  el: "#main",
  data() {
    return {
      hello_world: 'Vue support avail but not necessary'
    }
  }
});

$(function() {
  console.log('jquery is exposed to all modules by default');
});
